export var MenuEventName;
(function (MenuEventName) {
    MenuEventName["ClickedItem"] = "Clicked Product Menu Item";
})(MenuEventName || (MenuEventName = {}));
export var MenuEventProperty;
(function (MenuEventProperty) {
    MenuEventProperty["Destination"] = "destination";
    MenuEventProperty["Source"] = "source";
})(MenuEventProperty || (MenuEventProperty = {}));
export var MenuApp;
(function (MenuApp) {
    MenuApp["Field"] = "Field";
    MenuApp["Intel"] = "Intel";
    MenuApp["Pro"] = "Pro";
})(MenuApp || (MenuApp = {}));
